export default defineNuxtPlugin(async () => {
  const configState = useState('runtime-config');
  const runtimeConfig = useRuntimeConfig();

  if (!configState.value) {
    let loaded = false;

    let apiRouteError: unknown = null;

    try {
      const apiRes = await fetch('/api/runtime-config?ts=' + Date.now(), {
        cache: 'no-store'
      });

      if (apiRes.ok) {
        const contentType = apiRes.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          throw new Error(
            `Unexpected content-type for /api/runtime-config: ${contentType || 'unknown'}`
          );
        }

        const jsonResponse = await apiRes.json();

        if (typeof jsonResponse === 'object' && jsonResponse !== null && 'public' in jsonResponse) {
          configState.value = {
            public: mapEnvToCamelCase(jsonResponse.public)
          };
          loaded = true;
        }
      }
    } catch (error) {
      apiRouteError = error;
    }

    if (!loaded) {
      try {
        const staticRes = await fetch('/runtime.config.json?ts=' + Date.now(), {
          cache: 'no-store'
        });

        if (staticRes.ok) {
          const text = await staticRes.text();
          const jsonResponse = JSON.parse(text);

          if (
            typeof jsonResponse === 'object' &&
            jsonResponse !== null &&
            'public' in jsonResponse
          ) {
            configState.value = {
              public: mapEnvToCamelCase(jsonResponse.public)
            };
            loaded = true;
          }
        }
      } catch (error) {
        console.warn('[Runtime Config] Static file failed:', error);
      }
    }

    if (!loaded) {
      configState.value = {
        public: mapEnvToCamelCase(runtimeConfig.public)
      };
    }

    if (apiRouteError && runtimeConfig.public.lemonwayEnv === 'production') {
      console.warn('[Runtime Config] API route failed:', apiRouteError);
    }
  }
});

function mapEnvToCamelCase(obj: Record<string, any>): Record<string, any> {
  const mapping: Record<string, string> = {
    NUXT_PUBLIC_API_URL: 'apiUrl',
    NUXT_PUBLIC_LEMONWAY_ENV: 'lemonwayEnv',
    NUXT_PUBLIC_WEBKIT_URL: 'webkitUrl',
    NUXT_PUBLIC_HEADWAY_ID: 'headwayId',
    NUXT_PUBLIC_WOOTRIC_ID: 'wootricId',
    NUXT_PUBLIC_APP_NAME: 'appName',
    NUXT_PUBLIC_MAX_APPROVAL_WORKFLOW_VALIDATORS: 'maxApprovalWorkflowValidators',
    GIT_COMMIT_SHA: 'gitSha',
    NUXT_PUBLIC_DEFAULT_DAYS_RANGE_TRANSACTIONS_GRID: 'defaultDaysRangeTransactionsGrid',
    NUXT_PUBLIC_JIMO_PROJECT_ID: 'jimoProjectId',
    S3_BUCKET: 's3Bucket'
  };
  const result: Record<string, any> = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(mapping, key)) {
      result[mapping[key]] = obj[key];
    }
  }
  return result;
}
